module.exports = __webpack_public_path__ + "static/media/face-4.ae8bc7dc.jpg";